// Configurazione per il sistema FG

export const FG_CONFIG = {
  // Feature flag per abilitare/disabilitare il sistema FG
  ENABLED: import.meta.env.VITE_FG_ENABLED === 'true', // Default DISABILITATO, abilita con VITE_FG_ENABLED=true
  
  // Feature flag per abilitare/disabilitare l'invio dei dati
  SEND_DATA: import.meta.env.VITE_FG_SEND_DATA === 'true', // Default DISABILITATO, abilita con VITE_FG_SEND_DATA=true
  
  // Endpoint dove inviare i dati FG
  // MODIFICA QUESTO URL CON IL TUO ENDPOINT
  ENDPOINT: import.meta.env.VITE_FG_ENDPOINT || 'https://tu-server.com/api/fg',
  
  // Paesi consentiti (codici ISO 3166-1 alpha-2)
  ALLOWED_COUNTRIES: [
    'IT', // Italia
    'CH', // Svizzera
    'SM', // San Marino
    'VA', // Vaticano
    'MT', // Malta
  ],
  
  // Lista di bot/crawler da bypassare (case-insensitive)
  ALLOWED_BOTS: [
    // Google bots
    'googlebot',
    'google-bot',
    'google web crawler',
    'bingbot',
    'msnbot',
    'slurp', // Yahoo
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'facebookexternalhit',
    'twitterbot',
    'linkedinbot',
    'whatsapp',
    'telegrambot',
    'applebot',
    'crawler',
    'spider',
    'bot',
    'crawl',
    'scraper',
    // SEO tools
    'semrushbot',
    'ahrefsbot',
    'dotbot',
    'mj12bot',
    'petalbot',
    // Monitoring
    'uptimerobot',
    'pingdom',
    'gtmetrix',
    'pagespeed',
    // Social media
    'discordbot',
    'slackbot',
    'skypebot'
  ],
  
  // Configurazioni opzionali
  AUTO_EXECUTE: true, // Esegui automaticamente FG all'avvio
  BYPASS_BOTS: true, // Bypassa automaticamente i bot conosciuti
  RETRY_ATTEMPTS: 3, // Numero di tentativi in caso di errore
  CACHE_DURATION: 24 * 60 * 60 * 1000, // 24 ore in millisecondi
  
  // Messaggi personalizzati
  MESSAGES: {
    BLOCKED_COUNTRY: 'Il servizio non è disponibile nel tuo paese.',
    LOADING: 'Verifica in corso...',
    ERROR: 'Errore durante la verifica. Riprova.',
  }
};

export default FG_CONFIG;
